/* eslint-disable semi */
import SasType from './SasType';
import moment from 'moment'

// Springフレームワーク対応のリクエストパラメータコンバータ
// 下記のような変換処理を行う
// 元データ {data:{users: [{name: 'XXX'}, {name: 'yyy'}]}}
// 変換後   data.users[0].name=xxx&data.users[1].name=yyy

var qs = require('qs');

class SpringConverter {
  isNull (val) {
    return (val === null) || (typeof val === 'undefined');
  }

  /**
   * GETパラメータをSpring形式にコンバートする
   * param:[1,2,3] は param=1&param=2&param=3 という形式で送信する
   * @param {*} params
   */
  stringifyParams (params) {
    if (this.isNull(params)) {
      return '';
    }
    return qs.stringify(params, { indices: false });
  }

  /**
   * POSTパラメータをSpring形式にコンバートする
   * param:[1,2,3] は param[0]=1&param[1]=2&param[2]=3 という形式で送信する
   * @param {*} data
   */
  stringifyData (data) {
    if (this.isNull(data)) {
      return '';
    }
    return this.convert(data, '').join('&');
  }

  /**
   * 変換再帰処理
   * @param {*} data
   * @param {*} prefix
   */
  convert (data, prefix) {
    const result = [];

    const type = SasType.decideType(data);
    if (type === SasType.OBJECT) {
      const localPrefix = prefix + ((prefix === '') ? '' : '.');
      Object.keys(data).forEach(key => {
        const paramName = `${localPrefix}${key}`;

        const value = data[key];
        const valueType = SasType.decideType(value);
        if (valueType === SasType.OBJECT || valueType === SasType.ARRAY) {
          Array.prototype.push.apply(result, this.convert(value, paramName));
        } else {
          const convertedName = this.encode(paramName);
          const convertedValue = this.getParamValue(value, valueType);
          result.push(`${convertedName}=${convertedValue}`);
        }
      })
    } else if (type === SasType.ARRAY) {
      data.forEach((value, index) => {
        const paramName = `${prefix}[${index}]`;

        const valueType = SasType.decideType(value);
        if (valueType === SasType.OBJECT || valueType === SasType.ARRAY) {
          Array.prototype.push.apply(result, this.convert(value, paramName));
        } else {
          const convertedName = this.encode(paramName);
          const convertedValue = this.getParamValue(value, valueType);
          result.push(`${convertedName}=${convertedValue}`);
        }
      });
    } else {
      console.error('Invalid data', data);
    }

    return result;
  }

  /**
   * 配列・オブジェクト以外の値の文字列変換処理
   * @param {*} value
   * @param {*} type
   */
  getParamValue (value, type) {
    if (this.isNull(value)) {
      return '';
    }
    switch (type) {
      case SasType.STR:
        return this.encode(value);
      case SasType.DATE:
        return this.encode(moment(value).format('YYYY/MM/DD HH:mm:ssZ'));
      default:
        return value;
    }
  }

  /**
   * @see qs utils
   */
  hexTable = (function () {
    var array = [];
    for (var i = 0; i < 256; ++i) {
      array.push('%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase());
    }
    return array;
  }());

  /**
   * @see qs utils
   * @param {*} str
   * @param {*} defaultEncoder
   * @param {*} charset
   */
  encode (str, defaultEncoder, charset) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) {
      return str;
    }

    var string = typeof str === 'string' ? str : String(str);

    if (charset === 'iso-8859-1') {
      return escape(string).replace(/%u[0-9a-f]{4}/gi, function ($0) {
        return '%26%23' + parseInt($0.slice(2), 16) + '%3B';
      });
    }

    var out = '';
    for (var i = 0; i < string.length; ++i) {
      var c = string.charCodeAt(i);

      if (
        c === 0x2D || // -
            c === 0x2E || // .
            c === 0x5F || // _
            c === 0x7E || // ~
            (c >= 0x30 && c <= 0x39) || // 0-9
            (c >= 0x41 && c <= 0x5A) || // a-z
            (c >= 0x61 && c <= 0x7A) // A-Z
      ) {
        out += string.charAt(i);
        continue;
      }

      if (c < 0x80) {
        out = out + this.hexTable[c];
        continue;
      }

      if (c < 0x800) {
        out = out + (this.hexTable[0xC0 | (c >> 6)] + this.hexTable[0x80 | (c & 0x3F)]);
        continue;
      }

      if (c < 0xD800 || c >= 0xE000) {
        out = out + (this.hexTable[0xE0 | (c >> 12)] + this.hexTable[0x80 | ((c >> 6) & 0x3F)] + this.hexTable[0x80 | (c & 0x3F)]);
        continue;
      }

      i += 1;
      c = 0x10000 + (((c & 0x3FF) << 10) | (string.charCodeAt(i) & 0x3FF));
      out += this.hexTable[0xF0 | (c >> 18)] +
      this.hexTable[0x80 | ((c >> 12) & 0x3F)] +
      this.hexTable[0x80 | ((c >> 6) & 0x3F)] +
      this.hexTable[0x80 | (c & 0x3F)];
    }

    return out;
  }

  /**
   * 値がnullの場合空文字に変換した値を返却する
   */
  null2EmptyString (src) {
    if (src === null || src === undefined) {
      return '';
    }

    const valueType = SasType.decideType(src);
    if (valueType === SasType.OBJECT) {
      // オブジェクト型
      const dst = {};
      for (const paramName in src) {
        const value = src[paramName];
        dst[paramName] = this.null2EmptyString(value);
      }
      return dst;
    } else if (valueType === SasType.ARRAY) {
      // 配列
      const dst = [];
      for (const idx in src) {
        const value = src[idx];
        dst[idx] = this.null2EmptyString(value);
      }
      return dst;
    } else {
      // オブジェクト型・配列以外
      return src;
    }
  }
}

export default new SpringConverter();



// WEBPACK FOOTER //
// ./src/core/libs/SpringConverter.js